import React from 'react';

/**
 * A UK number-plate styled badge — the site's signature motif.
 * Used sparingly for stock counts, car-card badges and stat highlights.
 */
const Plate = ({ children, className = '', tilt = false }) => (
  <span className={`plate ${tilt ? 'plate-tilt' : ''} ${className}`.trim()}>
    {children}
  </span>
);

export default Plate;
